// route-utils.js
import Router from 'vue-router'

/**
 *
 * @param {string}  path  Path of the route.
 * @param name name of the route
 * @param component the Vue component to use
 * @param headerLeft left header, defaults to BackButton
 * @param headerRight headerRight defaults to EmptyComponent
 * @param footer Sidebar is large platform otherwise footer and defaults to TabBar
 * @param title title, as per translation key
 * @param children eventual childer routes
 * @param full whatsadat
 * @param propFunc the function that you can pass to the props property, ex: function to extract parameter from query url
 * @returns {{path: *, components: {default: *, footer: *, headerRight: *, headerLeft: *}, children: *, meta: {title: *, full: (*|string)}, name: *, props: (*|boolean)}}
 */

const modalRoute = (path, name, component, title, props = {}, children) => {
  return {
    path,
    name,
    components: {
      headerLeft: BackButton,
      default: component
    },
    meta: {
      title,
    },
    children,
    props: {
      default: (route) => {
        return props === true || props === false
          ? props
          : {...route.params, ...props, mode: 'page'}
      }
    }
  }
}


/**
 * @param  {String|Function} middleware
 * @param  {Array} routes
 * @return {Array}
 */
function middleware (middleware, routes) {
  routes.forEach(route =>
    (route.middleware || (route.middleware = [])).unshift(middleware)
  )

  return routes
}


/**
 * Create a new router instance.
 *
 * @return {Router}
 */
function make (overridePreferences) {
  let routerPreferences = {
    scrollBehavior,
    hashbang: true,
    routes: []
  }
  routerPreferences = {...routerPreferences, ...overridePreferences}
  // routerPreferences.routes = routerPreferences.routes.map(beforeEnter)

  /*if (process.env.VUE_APP_USE_ROUTER_HISTORY === 'true') {
    routerPreferences.mode = 'history'
  }*/

  const router = new Router (routerPreferences)
  const scrollBehavior = (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition
    }

    if (to.hash) {
      return {selector: to.hash}
    }

    const [component] = router.getMatchedComponents({...to}).slice(-1)

    if (component && component.scrollToTop === false) {
      return {}
    }

    return {x: 0, y: 0}
  }
  return router
}


/**
 * Add beforeEnter guard to the route.
 *
 * @param {Object} route
 * @param {Object}
 */
function beforeEnter(route) {

  if (route.children) {
    route.children.forEach(beforeEnter)
  }

  if (!route.middleware) {
    return route
  }

  route.beforeEnter = (...args) => {
    if (!Array.isArray(route.middleware)) {
      route.middleware = [route.middleware]
    }

    route.middleware.forEach(middleware => {
      if (typeof middleware === 'function') {
        middleware(...args)
      } else if (routeMiddleware[middleware]) {
        routeMiddleware[middleware](...args)
      } else {
        throw Error(`Undefined middleware [${middleware}]`)
      }
    })
  }

  return route
}


/**
 * @param  {Route} to
 * @param  {Route} from
 * @param  {Object|undefined} savedPosition
 * @return {Object}
 */


const routeMiddleware = resolveMiddleware(
  require.context('./middleware', false, /.*\.js$/)
)
/**
 * @param  {Object} requireContext
 * @return {Object}
 */
function resolveMiddleware (requireContext) {
  return requireContext.keys()
    .map(file =>
      [file.replace(/(^.\/)|(\.js$)/g, ''), requireContext(file)]
    )
    .reduce((guards, [name, guard]) => (
      {...guards, [name]: guard.default}
    ), {})
}
export {
  modalRoute,
  middleware,
  make,
  beforeEnter
}



// WEBPACK FOOTER //
// ./src/router/route-utils.js